import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "to-do-add__heading" }
const _hoisted_2 = { class: "to-do-add__assignee-row" }
const _hoisted_3 = { class: "to-do-add__scope" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "to-do-add__label-row" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", null, "Label:", -1)
const _hoisted_7 = {
  key: 0,
  class: "to-do-add__dismiss-confirmation"
}
const _hoisted_8 = { class: "to-do-add__dismiss-controls" }
const _hoisted_9 = {
  key: 0,
  class: "to-do-add__footer"
}
const _hoisted_10 = { class: "to-do-add__footer-actions" }
const _hoisted_11 = {
  key: 0,
  class: "to-do-add__footer-divider",
  "aria-hidden": "true"
}
const _hoisted_12 = ["disabled", "onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseHeading = _resolveComponent("BaseHeading")!
  const _component_ToDoSelectUser = _resolveComponent("ToDoSelectUser")!
  const _component_TodoWidgetDatePicker = _resolveComponent("TodoWidgetDatePicker")!
  const _component_CustomLabel = _resolveComponent("CustomLabel")!
  const _component_BaseSubHeading = _resolveComponent("BaseSubHeading")!
  const _component_Editor = _resolveComponent("Editor")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ToDoContent = _resolveComponent("ToDoContent")!

  return (_openBlock(), _createBlock(_component_ToDoContent, {
    class: _normalizeClass([_ctx.className, "to-do-add"])
  }, {
    header: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_BaseHeading, {
          level: "2",
          color: "monochrome-06"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.toDo.id ? "Edit ToDo Item" : "Add ToDo Item"), 1)
          ]),
          _: 1
        })
      ])
    ]),
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_ToDoSelectUser, {
          rules: _ctx.validators.isRequired('Owner'),
          toDo: _ctx.toDo,
          onOnSelectedUsers: _ctx.onSelectedUsers,
          onOnSelectedTeams: _ctx.onSelectedTeams
        }, null, 8, ["rules", "toDo", "onOnSelectedUsers", "onOnSelectedTeams"]),
        _createElementVNode("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.recipientScopes, (scope) => {
            return (_openBlock(), _createElementBlock("button", {
              key: scope,
              type: "button",
              class: _normalizeClass(["to-do-add__scope-button", { 'is-active': _ctx.toDo.completionRule === scope }]),
              onClick: ($event: any) => (_ctx.handleInput({ id: 'completionRule', value: scope }))
            }, _toDisplayString(_ctx.$t(`toDoCompletionRule.${scope}`)), 11, _hoisted_4))
          }), 128))
        ])
      ]),
      _createVNode(_component_TodoWidgetDatePicker, {
        today: _ctx.today,
        tomorrow: _ctx.tomorrow,
        urgent: _ctx.toDo.urgent,
        date: _ctx.toDo.estimatedDeadline,
        onOnCheckboxTomorrow: _ctx.onCheckboxTomorrow,
        onOnCheckboxToday: _ctx.onCheckboxToday,
        onUpdateUrgent: _ctx.updateUrgent,
        onUpdateDate: _ctx.updateDate
      }, null, 8, ["today", "tomorrow", "urgent", "date", "onOnCheckboxTomorrow", "onOnCheckboxToday", "onUpdateUrgent", "onUpdateDate"]),
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createVNode(_component_CustomLabel, {
          label: _ctx.toDo.label,
          searchType: "TODO_ITEM",
          onOnLabelUpdate: _ctx.handleInput
        }, null, 8, ["label", "onOnLabelUpdate"])
      ]),
      (_ctx.isDismissConfirmationVisible)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createVNode(_component_BaseHeading, {
              level: "3",
              color: "monochrome-06"
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Dismiss ToDo ")
              ]),
              _: 1
            }),
            _createVNode(_component_BaseSubHeading, {
              size: "large",
              weight: "400",
              color: "monochrome-05",
              darkColor: "monochrome-04",
              class: "to-do-add__dismiss-description"
            }, {
              default: _withCtx(() => [
                _createTextVNode(" This ToDo will be permanently removed from Sent to Others and won’t appear in your active list. ")
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("button", {
                type: "button",
                class: "secondary-button btn",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isDismissConfirmationVisible = false))
              }, " Cancel "),
              _createElementVNode("button", {
                type: "button",
                class: "primary-button btn to-do-add__dismiss-confirm-button",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onDismissToDo && _ctx.onDismissToDo(...args)))
              }, " Dismiss ")
            ])
          ]))
        : (_openBlock(), _createBlock(_component_Field, {
            key: 1,
            modelValue: _ctx.toDoName,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.toDoName) = $event)),
            as: "div",
            validateOnBlur: false,
            name: "toDoDescription",
            class: "to-do__description__wrapper",
            rules: _ctx.validators.isRequired('Description')
          }, {
            default: _withCtx(() => [
              _createVNode(_component_Editor, {
                id: "toDoDescription",
                value: _ctx.toDo.structuredDescription.html,
                extensions: _ctx.extensions,
                triggerHandleInputOnMount: false,
                taskEditor: true,
                class: "to-do__description",
                onHandleInput: _ctx.handleInputEditor,
                onInput: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"]))
              }, null, 8, ["value", "extensions", "onHandleInput"]),
              _createVNode(_component_ErrorMessage, {
                class: "error-text error-text-small",
                name: "toDoDescription"
              })
            ]),
            _: 1
          }, 8, ["modelValue", "rules"]))
    ]),
    footer: _withCtx(({ validate, handleReset }) => [
      (!_ctx.isDismissConfirmationVisible)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("button", {
                type: "button",
                class: "back-button",
                onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onCancel && _ctx.onCancel(...args)))
              }, " Back "),
              (_ctx.canDismissToDo)
                ? (_openBlock(), _createElementBlock("span", _hoisted_11))
                : _createCommentVNode("", true),
              (_ctx.canDismissToDo)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    type: "button",
                    class: "to-do-add__dismiss-button",
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.isDismissConfirmationVisible = true))
                  }, " Dismiss "))
                : _createCommentVNode("", true)
            ]),
            (_ctx.toDoName.trim())
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  type: "button",
                  class: "primary-button primary-button_small btn",
                  disabled: _ctx.$wait.is('save.todo'),
                  onClick: ($event: any) => (_ctx.onValidateAndSave(validate, handleReset))
                }, " Save ", 8, _hoisted_12))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["class"]))
}